import "./NursingCareProviderPetahTikvaWithinHours.module.css";
import Header from "@/reusable_sections/Header";
import EquipmentHero from "./sections/EquipmentHero";
import RelatedServices from "./sections/RelatedServices";
import AcademicProgramsGrid from "./sections/AcademicProgramsGrid";
import FaqAccordion from "./sections/FaqAccordion";
import FinalCtaBanner from "./sections/FinalCtaBanner";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareProviderPetahTikvaWithinHoursPage() {
  return <div>
      <Header />
      <EquipmentHero />
      <RelatedServices />
      <AcademicProgramsGrid />
      <FaqAccordion />
      <FinalCtaBanner />
      <Footer />
    </div>;
}